import { createAction } from 'typesafe-actions';
import { IParentModal } from '@types';

export const setDocumentUrl = createAction('SET_DOCUMENT_URL', (payload: string) => payload)();
export const clearDocumentUrl = createAction('CLEAR_DOCUMENT_URL')();
